import script from "./PanelMarketing.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelMarketing.vue?vue&type=script&setup=true&lang=js"

import "./PanelMarketing.vue?vue&type=style&index=0&id=a0f42a28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0f42a28"]])

export default __exports__